export class CameraEventThreshold {
    constructor(public low: number, public medium: number, public high: number) { }
}

export class CameraEventThresholds {
    acceleration: CameraEventThreshold;
    braking: CameraEventThreshold;
    cornering: CameraEventThreshold;
    minThreshold: number;
    maxThreshold: number;

    constructor(acceleration: CameraEventThreshold, braking: CameraEventThreshold, cornering: CameraEventThreshold) {
        this.acceleration = acceleration;
        this.braking = braking;
        this.cornering = cornering;
        this.minThreshold = Math.min(acceleration.low, braking.low, cornering.low);
        this.maxThreshold = Math.max(acceleration.high, braking.high, cornering.high);
    }
}